var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vAlertHeader',{attrs:{"title":"OR Pay with PayPal","color":"#012169"}}),(!_vm.sdkLoaded)?_c('div',[_vm._v("Loading PayPal...")]):_c('div',{attrs:{"id":"paypal-button-container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }